module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAcBAMAAAD/8tBWAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTOTk5OPj4+Pj4+Tk5OTk5OPj4+Hh4ebm5uTk5OTk5OTk5GesWDYAAAALdFJOUwBEd7tdjMwRM6rmzYtE2wAAAG1JREFUKM9jYACBEuXsAAZUlvPu3bsTUFleQMbu7XDWBiCDFcTYvRGFNRvM2oTMgkju3gxn7WRgkAYzpjQgs6xBjAyQDXAWB4ixrQCFxQqzConFDHMSEosbxFqkpKSAxKqGOACoAMGSHmURywIAUkQaRTCCg8wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/quote.png
// module id = 46
// module chunks = 5